import type { ReactNode } from 'react';
import {
  appIconKeys,
  isMingcuteLineIconKey,
  isRegisteredAppIconName,
  normalizeAppIconName,
  resolveAppIconKey,
} from './app-icon-catalog';
import {
  type AppIconComponent,
  type AppIconProps,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  Award,
  BarChart3,
  Blocks,
  Book,
  Bot,
  Bug,
  Calendar,
  Camera,
  ChartColumn,
  Check,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleCheck,
  CircleHelp,
  CircleUserRound,
  Clapperboard,
  Clock,
  Clock3,
  CloudUpload,
  Coins,
  Cpu,
  CreditCard,
  Crown,
  Download,
  Eraser,
  Eye,
  EyeOff,
  FileImage,
  FileText,
  Filter,
  Gift,
  Globe,
  Grid,
  Grid2x2,
  History,
  Home,
  Image,
  ImageUp,
  Info,
  Laptop,
  LaptopMinimal,
  Layers,
  Layers3,
  LayoutDashboard,
  LayoutGrid,
  List,
  Loader2,
  Lock,
  LogIn,
  LogOut,
  Mail,
  Maximize,
  Menu,
  MessageCircle,
  MicVocal,
  Minimize,
  Monitor,
  Moon,
  MoonStar,
  More1,
  MoreHorizontal,
  MousePointerClick,
  Package,
  Palette,
  PanelLeft,
  Paperclip,
  Pencil,
  Play,
  Plus,
  Quote,
  RefreshCw,
  ScanEye,
  Search,
  Send,
  Settings,
  Settings2,
  Share2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Smartphone,
  Sparkles,
  Star,
  Sun,
  SunMedium,
  Terminal,
  ThumbsDown,
  ThumbsUp,
  Trash2,
  TrendingDown,
  TriangleAlert,
  Truck,
  Upload,
  User,
  User2,
  UserRound,
  Users,
  UsersRound,
  Video,
  Wand2,
  WandSparkles,
  Wrench,
  X,
  Zap,
} from './app-icons';
import { FluxBrandIcon } from './flux-brand-icon';
import {
  MingcuteLineAssetIcon,
  type MingcuteLineIconAssetMode,
} from './mingcute-line-asset-icon';
import { SeedanceBrandIcon } from './seedance-brand-icon';

export const coreAppIconEntries = [
  { name: 'ArrowLeft', icon: ArrowLeft },
  { name: 'ArrowRight', icon: ArrowRight },
  { name: 'ArrowUpRight', icon: ArrowUpRight },
  { name: 'Award', icon: Award },
  { name: 'BarChart3', icon: BarChart3 },
  { name: 'Blocks', icon: Blocks },
  { name: 'Book', icon: Book },
  { name: 'Bot', icon: Bot },
  { name: 'Bug', icon: Bug },
  { name: 'Calendar', icon: Calendar },
  { name: 'Camera', icon: Camera },
  { name: 'ChartColumn', icon: ChartColumn },
  { name: 'Check', icon: Check },
  { name: 'CheckSquare', icon: CheckSquare },
  { name: 'ChevronDown', icon: ChevronDown },
  { name: 'ChevronLeft', icon: ChevronLeft },
  { name: 'ChevronRight', icon: ChevronRight },
  { name: 'ChevronUp', icon: ChevronUp },
  { name: 'CircleCheck', icon: CircleCheck },
  { name: 'CircleHelp', icon: CircleHelp },
  { name: 'CircleUserRound', icon: CircleUserRound },
  { name: 'Clapperboard', icon: Clapperboard },
  { name: 'Clock', icon: Clock },
  { name: 'Clock3', icon: Clock3 },
  { name: 'CloudUpload', icon: CloudUpload },
  { name: 'Coins', icon: Coins },
  { name: 'Cpu', icon: Cpu },
  { name: 'CreditCard', icon: CreditCard },
  { name: 'Crown', icon: Crown },
  { name: 'Download', icon: Download },
  { name: 'Eraser', icon: Eraser },
  { name: 'Eye', icon: Eye },
  { name: 'EyeOff', icon: EyeOff },
  { name: 'FileImage', icon: FileImage },
  { name: 'FileText', icon: FileText },
  { name: 'Filter', icon: Filter },
  { name: 'Flux', icon: FluxBrandIcon },
  { name: 'Seedance', icon: SeedanceBrandIcon },
  { name: 'Gift', icon: Gift },
  { name: 'Globe', icon: Globe },
  { name: 'Grid', icon: Grid },
  { name: 'Grid2x2', icon: Grid2x2 },
  { name: 'History', icon: History },
  { name: 'Home', icon: Home },
  { name: 'Image', icon: Image },
  { name: 'ImageUp', icon: ImageUp },
  { name: 'Info', icon: Info },
  { name: 'Laptop', icon: Laptop },
  { name: 'LaptopMinimal', icon: LaptopMinimal },
  { name: 'Layers', icon: Layers },
  { name: 'Layers3', icon: Layers3 },
  { name: 'LayoutDashboard', icon: LayoutDashboard },
  { name: 'LayoutGrid', icon: LayoutGrid },
  { name: 'List', icon: List },
  { name: 'Loader2', icon: Loader2 },
  { name: 'Lock', icon: Lock },
  { name: 'LogIn', icon: LogIn },
  { name: 'LogOut', icon: LogOut },
  { name: 'Mail', icon: Mail },
  { name: 'Maximize', icon: Maximize },
  { name: 'Menu', icon: Menu },
  { name: 'MessageCircle', icon: MessageCircle },
  { name: 'MicVocal', icon: MicVocal },
  { name: 'Minimize', icon: Minimize },
  { name: 'Monitor', icon: Monitor },
  { name: 'Moon', icon: Moon },
  { name: 'MoonStar', icon: MoonStar },
  { name: 'More1', icon: More1 },
  { name: 'MoreHorizontal', icon: MoreHorizontal },
  { name: 'MousePointerClick', icon: MousePointerClick },
  { name: 'Package', icon: Package },
  { name: 'Palette', icon: Palette },
  { name: 'PanelLeft', icon: PanelLeft },
  { name: 'Paperclip', icon: Paperclip },
  { name: 'Pencil', icon: Pencil },
  { name: 'Play', icon: Play },
  { name: 'Plus', icon: Plus },
  { name: 'Quote', icon: Quote },
  { name: 'RefreshCw', icon: RefreshCw },
  { name: 'ScanEye', icon: ScanEye },
  { name: 'Search', icon: Search },
  { name: 'Send', icon: Send },
  { name: 'Settings', icon: Settings },
  { name: 'Settings2', icon: Settings2 },
  { name: 'Share2', icon: Share2 },
  { name: 'Shield', icon: Shield },
  { name: 'ShieldAlert', icon: ShieldAlert },
  { name: 'ShieldCheck', icon: ShieldCheck },
  { name: 'Smartphone', icon: Smartphone },
  { name: 'Sparkles', icon: Sparkles },
  { name: 'Star', icon: Star },
  { name: 'Sun', icon: Sun },
  { name: 'SunMedium', icon: SunMedium },
  { name: 'Terminal', icon: Terminal },
  { name: 'ThumbsDown', icon: ThumbsDown },
  { name: 'ThumbsUp', icon: ThumbsUp },
  { name: 'Trash2', icon: Trash2 },
  { name: 'TrendingDown', icon: TrendingDown },
  { name: 'TriangleAlert', icon: TriangleAlert },
  { name: 'Truck', icon: Truck },
  { name: 'Upload', icon: Upload },
  { name: 'User', icon: User },
  { name: 'User2', icon: User2 },
  { name: 'UserRound', icon: UserRound },
  { name: 'Users', icon: Users },
  { name: 'UsersRound', icon: UsersRound },
  { name: 'Video', icon: Video },
  { name: 'Wand2', icon: Wand2 },
  { name: 'WandSparkles', icon: WandSparkles },
  { name: 'Wrench', icon: Wrench },
  { name: 'X', icon: X },
  { name: 'Zap', icon: Zap },
] satisfies Array<{ name: string; icon: AppIconComponent }>;

const APP_ICON_MAP = new Map(
  coreAppIconEntries.map((entry) => [
    normalizeAppIconName(entry.name),
    entry.icon,
  ])
);

export type AppIconOption = {
  name: string;
  label: string;
};

export { isRegisteredAppIconName, normalizeAppIconName };

export function getAppIconOptions(): AppIconOption[] {
  return appIconKeys.map((key) => ({
    name: key,
    label: key,
  }));
}

export function resolveAppIconComponent(
  name: string | null | undefined,
  fallback: AppIconComponent
): AppIconComponent;
export function resolveAppIconComponent(
  name: string | null | undefined,
  fallback?: null
): AppIconComponent | null;
export function resolveAppIconComponent(
  name: string | null | undefined,
  fallback: AppIconComponent | null = null
) {
  const normalized = normalizeAppIconName(name);
  if (!normalized) {
    return fallback;
  }

  return APP_ICON_MAP.get(normalized) ?? fallback;
}

export function renderAppIcon(params: {
  assetMode?: MingcuteLineIconAssetMode;
  name: string | null | undefined;
  className?: string;
  fallback?: AppIconComponent | null;
}): ReactNode {
  return (
    <AppIconByName
      assetMode={params.assetMode}
      className={params.className}
      fallback={params.fallback}
      name={params.name}
    />
  );
}

export function AppIconByName({
  assetMode = 'individual',
  fallback = null,
  name,
  ...props
}: Omit<AppIconProps, 'name'> & {
  assetMode?: MingcuteLineIconAssetMode;
  fallback?: AppIconComponent | null;
  name: string | null | undefined;
}) {
  const CoreIcon = resolveAppIconComponent(name, null);
  if (CoreIcon) {
    return <CoreIcon {...props} />;
  }

  const iconKey = resolveAppIconKey(name?.trim().toLowerCase());
  if (isMingcuteLineIconKey(iconKey)) {
    return (
      <MingcuteLineAssetIcon
        assetMode={assetMode}
        iconKey={iconKey}
        {...props}
      />
    );
  }

  const FallbackIcon = fallback;
  return FallbackIcon ? <FallbackIcon {...props} /> : null;
}
